import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchStockTakes} from "./actions";
import ListView from "../common/ListView";
import DateTimeDisplay from "../common/DateTimeDisplay";
import {Link} from "react-router-dom";
import EndStockTakeModal from "./EndStockTakeModal";
import {Dropdown, Icon, Menu} from "antd";
import {parseQS} from "../utils/qs";

class StockTakesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    /* state */
    salonId: PropTypes.string,
    search: PropTypes.object.isRequired,
    /* actions */
    searchStockTakes: PropTypes.func.isRequired,
  };

  state = {
    query: {},
    endStockTakeModalId: '',
  };

  componentDidMount() {
    const query = parseQS(this.props.location.search);
    this.setState({
      query,
      endStockTakeModalId: query.end || ''
    });
  }

  handleMenuEndClick = (id) => {
    this.setState({endStockTakeModalId: id});
  };

  handleEndStockTakeModalClose = (refresh) => {
    this.setState({endStockTakeModalId: ''});
    const {query: {end}} = this.state;
    if (end) {
      this.props.history.replace('/stock-take/list');
      this.listView.refresh();
    } else if (refresh) {
      this.listView.refresh();
    }
  };

  render() {
    const {
      history, searchStockTakes, salonId,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const {endStockTakeModalId} = this.state;
    const showEndStockTakeModal = !!endStockTakeModalId;
    const endStockTakeModalData = showEndStockTakeModal
      ? results.find(stockTake => stockTake.stockTakeId === endStockTakeModalId)
      : null;
    const columns = [
      {
        title: 'Started At',
        dataIndex: 'startedAt',
        key: 'startedAt',
        fixed: 'left',
        width: 165,
        sorter: true,
        render: startedAt => <DateTimeDisplay dateTime={startedAt}/>,
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true,
      },
      {
        title: 'Ended At',
        dataIndex: 'endedAt',
        key: 'endedAt',
        sorter: true,
        render: endedAt => <DateTimeDisplay dateTime={endedAt}/>,
      },
      {
        title: 'Uncounted',
        dataIndex: 'uncounted',
        key: 'uncounted',
        sorter: true,
      },
      {
        title: 'Counted',
        dataIndex: 'counted',
        key: 'counted',
        sorter: true,
      },
      {
        title: 'Discrepancies',
        dataIndex: 'discrepancies',
        key: 'discrepancies',
        sorter: true,
      },
      {
        title: 'Adjusted',
        dataIndex: 'adjusted',
        key: 'adjusted',
        sorter: true,
      },
      {
        title: 'Action',
        fixed: 'right',
        width: 130,
        key: 'action',
        render: (_, {endedAt, stockTakeId}) => endedAt === null
          ? [
            <Link key="take-stock" to={`/stock-take/take/${stockTakeId}`}>Count</Link>,
            ' | ',
            <Link key="bulk-take-stock" to={`/stock-take/bulk-take/${stockTakeId}`}>Bulk</Link>,
            ' | ',
            <Dropdown key="dropdown" overlay={
              <Menu>
                <Menu.Item key="0">
                  <Link key="discrepancies" to={`/stock-take/discrepancies/${stockTakeId}`}>Discrepancies</Link>
                </Menu.Item>
                <Menu.Item key="1">
                  <Link key="uncounted" to={`/stock-take/uncounted/${stockTakeId}`}>Uncounted</Link>
                </Menu.Item>
                <Menu.Item key="2">
                  <Link key="uncounted" to={`/stock-take/history/${stockTakeId}`}>History</Link>
                </Menu.Item>
                <Menu.Divider/>
                <Menu.Item key="3">
                  <Link key="end" to="#" onClick={() => this.handleMenuEndClick(stockTakeId)}>End</Link>
                </Menu.Item>
              </Menu>
            } trigger={['click']}>
              <a className="ant-dropdown-link">
                More <Icon type="down" />
              </a>
            </Dropdown>
          ] : [
            <Dropdown key="dropdown" overlay={
              <Menu>
                <Menu.Item key="0">
                  <Link key="discrepancies" to={`/stock-take/discrepancies/${stockTakeId}`}>Discrepancies</Link>
                </Menu.Item>
                <Menu.Item key="1">
                  <Link key="uncounted" to={`/stock-take/uncounted/${stockTakeId}`}>Uncounted</Link>
                </Menu.Item>
                <Menu.Item key="2">
                  <Link key="uncounted" to={`/stock-take/history/${stockTakeId}`}>History</Link>
                </Menu.Item>
              </Menu>
            } trigger={['click']}>
              <a className="ant-dropdown-link">
                More <Icon type="down" />
              </a>
            </Dropdown>
          ]
      }
    ];
    return (
      <ListView
        ref={ref => this.listView = ref}
        salonId={salonId}
        title="Stock-takes"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchStockTakes}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/stock-take/start')}
        rowKey="stockTakeId"
        scroll={{x: 1050}}
      >
        <EndStockTakeModal
          visible={showEndStockTakeModal}
          stockTake={endStockTakeModalData}
          onClose={this.handleEndStockTakeModalClose}
        />
      </ListView>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.stockTake.stockTakesLoading,
  salonId: state.salon.selectedSalonId,
  stockTakes: state.stockTake.stockTakes,
  search: state.stockTake.search,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchStockTakes,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(StockTakesPage);



// WEBPACK FOOTER //
// ./src/StockTake/StockTakesPage.js